// extracted by mini-css-extract-plugin
export default {"field":"styles_field__mfUPS","label":"styles_label__71TGA","input":"styles_input__oWiu2"};